module.exports = __webpack_public_path__ + "img/04.36a07a33.gif";